import React from 'react'
import PropTypes from 'prop-types'
import { map, reduce, isEmpty, get } from 'lodash-es'

import { IconComponent } from '../../../../components'
import { ReadMore } from '../../../../../RoomUI/components/ReadMore/ReadMore'
import {
  SpeakerBaseDetailsComponent,
  ExpandedListActionsComponent,
} from '../index'

import './ExpandedListComponent.scss'

const socialIcons = [
  { name: 'facebook', size: [11, 11] },
  { name: 'twitter', size: [12, 12] },
  { name: 'linkedin', size: [12, 12] },
]

const getIcon = (icon, isDisabled) => (
  <IconComponent {...icon} color={isDisabled ? 'CCC' : 'AAAAAA'} />
)

const renderSocialLinks = (speaker) => {
  const items = reduce(
    socialIcons,
    (acc, icon) => {
      const link = get(speaker, `${icon.name}_url`)

      if (!isEmpty(link)) {
        acc.push(
          <li key={icon.name} className="social-link">
            <a target="_blank" rel="noopener noreferrer" href={link}>
              {getIcon(icon)}
            </a>
          </li>
        )
      }

      return acc
    },
    []
  )

  if (items.length === 0) {
    return null
  }

  return <ul className="social-links">{items}</ul>
}

const renderBio = (bio) => {
  if (isEmpty(bio)) {
    return null
  }

  return (
    <div className="bio">
      <ReadMore lines={3}>{bio}</ReadMore>
    </div>
  )
}

const renderSpeaker = (speaker, opt) => {
  const { openCrudModal, onSendClick, sendInviteSpeakerId, viewOnly } = opt
  const { live_speaker_id: speakerId } = speaker

  return (
    <li key={speakerId} className="speakers-list-item">
      <div className="list-header">
        <SpeakerBaseDetailsComponent speaker={speaker} viewOnly={viewOnly} />
        <ExpandedListActionsComponent
          speakerId={speakerId}
          openCrudModal={openCrudModal}
          onSendClick={onSendClick}
          sendInviteSpeakerId={sendInviteSpeakerId}
          viewOnly={viewOnly}
        />
      </div>
      {renderSocialLinks(speaker)}
      {renderBio(speaker.bio)}
    </li>
  )
}

const ExpandedListComponent = ({ speakers, ...rest }) => {
  return (
    <div className="expanded-list-component">
      <ul className="speakers-list">
        {map(speakers, (speaker) => renderSpeaker(speaker, rest))}
      </ul>
    </div>
  )
}

ExpandedListComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  speakers: PropTypes.arrayOf(PropTypes.object),
  openCrudModal: PropTypes.func,
  onSendClick: PropTypes.func,
  sendInviteSpeakerId: PropTypes.string,
  viewOnly: PropTypes.bool,
}

// eslint-disable-next-line import-x/no-default-export
export default ExpandedListComponent
